<ion-card class="tarjeta-solicitudes-card" #tarjetaCard>
  <ion-card-header>
    <div class="header-container">
      <div class="header-fila-superior">
        <div class="titulo-container">
          <ion-card-title>{{ titulo }}</ion-card-title>
          <ion-card-subtitle *ngIf="subtitulo">{{ subtitulo }}</ion-card-subtitle>
        </div>
        <div class="acciones-header">
          <ion-button *ngIf="informacion" [id]="idUnico" fill="clear" size="small" class="boton-informacion"
            aria-label="Información">
            <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      </div>
      <div class="buscador-container">
        <ion-searchbar [(ngModel)]="terminoBusqueda" (ionInput)="buscarSolicitudes()" (ionClear)="limpiarBusqueda()"
          placeholder="Buscar..." debounce="700" class="buscador-solicitudes"></ion-searchbar>
      </div>
    </div>
  </ion-card-header>
  <ion-card-content>
    <div class="loading-container" *ngIf="cargando()">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Cargando datos...</p>
    </div>

    <div class="sin-datos" *ngIf="!cargando() && solicitudes().length === 0">
      <ion-icon name="document-text-outline"></ion-icon>
      <p>No hay solicitudes pendientes</p>
    </div>

    <div class="tabla-wrapper" *ngIf="!cargando() && solicitudes().length > 0">
      <div class="tabla-container">
        <table class="tabla-solicitudes">
          <thead>
            <tr>
              <th *ngFor="let col of columnasOrdenables" class="th-sortable" (click)="onSortColumn(col.id)"
                [attr.aria-sort]="isColumnaOrdenActiva(col.sortKey) ? (sortOrder === 'asc' ? 'ascending' : 'descending') : null"
                [attr.title]="'Ordenar por ' + col.label">
                <span class="th-sortable-content">
                  <span class="th-sortable-label">{{ col.label }}</span>
                  <span class="th-sort-icon" [class.activo]="isColumnaOrdenActiva(col.sortKey)" aria-hidden="true">
                    <ion-icon
                      [name]="isColumnaOrdenActiva(col.sortKey) ? (sortOrder === 'asc' ? 'arrow-up' : 'arrow-down') : 'swap-vertical-outline'"></ion-icon>
                  </span>
                </span>
              </th>
              <th class="col-accion"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of solicitudes()">
              <td class="col-usuario">{{ nombreUsuarioCorto(item) }}</td>
              <td class="col-tipo">{{ item.tipo_solicitud }}</td>
              <td class="col-accion">
                <ion-button fill="clear" size="small" color="primary" class="btn-ver"
                  (click)="irADiagnosticoProductor(item)" aria-label="Ir al diagnóstico del productor">
                  <ion-icon name="eye-outline" slot="icon-only"></ion-icon>
                </ion-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="paginacion-container">
        <div class="info-paginacion">
          <span>Pág {{ paginaActual }} de {{ totalPaginas }} ({{ totalRegistros }}
            <span class="label-registros-completo">registro{{ totalRegistros !== 1 ? 's' : '' }}</span><span
              class="label-registros-corto">reg{{ totalRegistros !== 1 ? 's' : '' }}</span>)</span>
        </div>
        <div class="controles-paginacion">
          <ion-button fill="clear" size="small" (click)="irPagina(1)" [disabled]="paginaActual <= 1"
            aria-label="Primera página">
            <ion-icon slot="icon-only" name="play-skip-back-outline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" size="small" (click)="paginaAnterior()" [disabled]="paginaActual <= 1"
            aria-label="Página anterior">
            <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
          </ion-button>
          <div class="numeros-pagina">
            <ion-button *ngFor="let pagina of getPaginasArray()" [fill]="pagina === paginaActual ? 'solid' : 'clear'"
              [color]="pagina === paginaActual ? 'primary' : 'medium'" size="small" (click)="irPagina(pagina)">
              {{ pagina }}
            </ion-button>
          </div>
          <ion-button fill="clear" size="small" (click)="paginaSiguiente()" [disabled]="paginaActual >= totalPaginas"
            aria-label="Página siguiente">
            <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
          </ion-button>
          <ion-button fill="clear" size="small" (click)="irPagina(totalPaginas)"
            [disabled]="paginaActual >= totalPaginas" aria-label="Última página">
            <ion-icon slot="icon-only" name="play-skip-forward-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </ion-card-content>
</ion-card>

<ion-popover *ngIf="informacion" [trigger]="idUnico" [triggerAction]="'click'" reference="trigger" [side]="'top'"
  [alignment]="'center'">
  <ng-template>
    <div class="popover-informacion">
      <p>{{ informacion }}</p>
    </div>
  </ng-template>
</ion-popover>